// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Icon Component */
:host {
  display: inline-flex;
  align-self: center;
  contain: layout;
  place-self: center;
  position: relative;
}

svg {
  color: var(--ids-icon-color-default);
  height: var(--ids-icon-height-default);
  width: var(--ids-icon-width-default);
}

:host([hidden]) {
  display: none;
}

.mirrored {
  transform: scaleX(-1);
}

:host([icon=more]) svg,
:host([icon=vertical-ellipsis]) svg {
  height: 19px;
}

:host([icon=add]) svg {
  width: 17px;
}

:host([icon=logo]) svg path:nth-child(1) {
  display: none;
}

:host([icon=logo-primary]) svg {
  stroke: transparent;
}

:host([compact=true]) svg {
  height: calc(var(--ids-button-icon-compact-height) - 2px);
  width: calc(var(--ids-button-icon-compact-width) - 2px);
}

:host([icon=favicon]) {
  color: var(--ids-icon-infor-color);
}
:host([icon=favicon]) path:nth-child(2) {
  fill: white;
}

:host([icon=genai]) .insights-stop-1 {
  stop-color: var(--ids-button-ai-color-icon-primary);
}
:host([icon=genai]) .insights-stop-2 {
  stop-color: var(--ids-button-ai-color-icon-secondary);
}

:host(.editor-forecolor) .stop-underline,
:host(.editor-forecolor) .stop-base {
  stop-color: var(--ids-button-formatter-color-text-default);
}

:host(.editor-forecolor.is-active) .stop-underline {
  stop-color: var(--forecolor-active-color);
}

:host(#m-10) {
  margin-top: 10px;
}

.text-badge {
  position: absolute;
  background: var(--ids-text-badge-color-background-success);
  color: var(--ids-text-badge-color-text);
  text-align: center;
  border-radius: var(--ids-text-badge-border-radius);
  width: var(--ids-text-badge-width);
  height: var(--ids-text-badge-height);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--ids-font-family-default);
  font-size: var(--ids-font-size-xs);
  padding: 0 6px;
  border: 1.5px solid var(--ids-text-badge-color-border, var(--ids-color-background-default));
  box-sizing: border-box;
}
.text-badge.top-right {
  bottom: calc(100% - var(--ids-text-badge-height) / 2);
  left: calc(100% - var(--ids-text-badge-width) / 2);
}
.text-badge.top-left {
  bottom: calc(100% - var(--ids-text-badge-height) / 2);
  right: calc(100% - var(--ids-text-badge-width) / 2);
}
.text-badge.error {
  background: var(--ids-notification-badge-error-color-background);
}
.text-badge.success {
  background: var(--ids-notification-badge-success-color-background);
}
.text-badge.warning {
  background: var(--ids-notification-badge-warning-color-background);
}
.text-badge.info {
  background: var(--ids-notification-badge-info-color-background);
}

.notification-badge {
  background-color: var(--ids-notification-badge-error-color-background);
  border-radius: var(--ids-notification-badge-border-radius);
  height: var(--ids-notification-badge-size);
  width: var(--ids-notification-badge-size);
  position: absolute;
  border: 1.5px solid var(--ids-notification-badge-color-border, var(--ids-color-background-default));
  box-sizing: border-box;
}
.notification-badge.info, .notification-badge.base {
  background-color: var(--ids-notification-badge-info-color-background);
}
.notification-badge.error {
  background-color: var(--ids-notification-badge-error-color-background);
}
.notification-badge.success {
  background-color: var(--ids-notification-badge-success-color-background);
}
.notification-badge.warning {
  background-color: var(--ids-notification-badge-warning-color-background);
}
.notification-badge {
  /**
  * positioning notification badge
  */
}
.notification-badge.top-right {
  bottom: calc(100% - var(--ids-notification-badge-size));
  left: calc(100% - var(--ids-notification-badge-size));
}
.notification-badge.top-left {
  bottom: calc(100% - var(--ids-notification-badge-size));
  left: 0;
}
.notification-badge.bottom-right {
  bottom: 0;
  left: calc(100% - var(--ids-notification-badge-size));
}
.notification-badge.bottom-left {
  bottom: 0;
  left: 0;
}

:host([disabled]) .notification-badge {
  background-color: var(--ids-alert-color-error-disabled);
  border: 1.5px solid var(--ids-notification-badge-color-border, var(--ids-color-background-default));
  box-sizing: border-box;
}
:host([disabled]) .notification-badge.info, :host([disabled]) .notification-badge.base {
  background-color: var(--ids-alert-color-info-disabled);
}
:host([disabled]) .notification-badge.error {
  background-color: var(--ids-alert-color-error-disabled);
}
:host([disabled]) .notification-badge.success {
  background-color: var(--ids-alert-color-success-disabled);
}
:host([disabled]) .notification-badge.warning {
  background-color: var(--ids-alert-color-warning-disabled);
}

[class^=status-color] {
  background-color: var(--ids-icon-status-color-blue-color-background);
  color: var(--ids-icon-status-color-blue-color-text);
  border-radius: var(--ids-icon-status-color-border-radius);
  padding: var(--ids-icon-status-color-padding);
  overflow: visible;
}

.status-color-red {
  background-color: var(--ids-icon-status-color-red-color-background);
  color: var(--ids-icon-status-color-red-color-text);
}

.status-color-orange {
  background-color: var(--ids-icon-status-color-orange-color-background);
  color: var(--ids-icon-status-color-orange-color-text);
}

.status-color-green {
  background-color: var(--ids-icon-status-color-green-color-background);
  color: var(--ids-icon-status-color-green-color-text);
}

.status-color-blue {
  background-color: var(--ids-icon-status-color-blue-color-background);
  color: var(--ids-icon-status-color-blue-color-text);
}

.status-color-teal {
  background-color: var(--ids-icon-status-color-teal-color-background);
  color: var(--ids-icon-status-color-teal-color-text);
}

.status-color-purple {
  background-color: var(--ids-icon-status-color-purple-color-background);
  color: var(--ids-icon-status-color-purple-color-text);
}

.status-color-gray {
  background-color: var(--ids-icon-status-color-neutral-color-background);
  color: var(--ids-icon-status-color-neutral-color-text);
}

.status-color-yellow {
  background-color: var(--ids-icon-status-color-yellow-color-background);
  color: var(--ids-icon-status-color-yellow-color-text);
}

.status-color-error {
  background-color: var(--ids-icon-status-color-error-color-background);
  color: var(--ids-icon-status-color-error-color-text);
}

.status-color-warning {
  background-color: var(--ids-icon-status-color-warning-color-background);
  color: var(--ids-icon-status-color-warning-color-text);
}

.status-color-alert {
  background-color: var(--ids-icon-status-color-alert-color-background);
  color: var(--ids-icon-status-color-alert-color-text);
}

.status-color-info {
  background-color: var(--ids-icon-status-color-info-color-background);
  color: var(--ids-icon-status-color-info-color-text);
}

.status-color-success {
  background-color: var(--ids-icon-status-color-success-color-background);
  color: var(--ids-icon-status-color-success-color-text);
}

.status-color-caution {
  background-color: var(--ids-icon-status-color-caution-color-background);
  color: var(--ids-icon-status-color-caution-color-text);
}

:host(.calendar-event-header-icon) svg {
  background-color: var(--ids-color-transparent) !important;
}

[fill="#7928E1"] {
  color: transparent;
  fill: var(--ids-button-ai-sparkle-icon-color-fill);
}

[fill="#161618"] {
  fill: currentColor;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-icon/ids-icon.scss"],"names":[],"mappings":"AAAA,uBAAA;AACA;EACE,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,oCAAA;EACA,sCAAA;EACA,oCAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAGA;;EAEE,YAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAIE;EACE,aAAA;AADJ;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,yDAAA;EACA,uDAAA;AAFF;;AAKA;EACE,kCAAA;AAFF;AAIE;EACE,WAAA;AAFJ;;AAOE;EACE,mDAAA;AAJJ;AAOE;EACE,qDAAA;AALJ;;AAUE;;EAEE,0DAAA;AAPJ;;AAYE;EACE,yCAAA;AATJ;;AAaA;EACE,gBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,0DAAA;EACA,uCAAA;EACA,kBAAA;EACA,kDAAA;EACA,kCAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,kCAAA;EACA,cAAA;EACA,2FAAA;EACA,sBAAA;AAVF;AAYE;EACE,qDAAA;EACA,kDAAA;AAVJ;AAaE;EACE,qDAAA;EACA,mDAAA;AAXJ;AAcE;EACE,gEAAA;AAZJ;AAeE;EACE,kEAAA;AAbJ;AAgBE;EACE,kEAAA;AAdJ;AAiBE;EACE,+DAAA;AAfJ;;AAmBA;EACE,sEAAA;EACA,0DAAA;EACA,0CAAA;EACA,yCAAA;EACA,kBAAA;EACA,mGAAA;EACA,sBAAA;AAhBF;AAmBE;EAEE,qEAAA;AAlBJ;AAqBE;EACE,sEAAA;AAnBJ;AAsBE;EACE,wEAAA;AApBJ;AAuBE;EACE,wEAAA;AArBJ;AAHA;EA2BE;;GAAA;AAnBF;AAsBE;EACE,uDAAA;EACA,qDAAA;AApBJ;AAuBE;EACE,uDAAA;EACA,OAAA;AArBJ;AAwBE;EACE,SAAA;EACA,qDAAA;AAtBJ;AAyBE;EACE,SAAA;EACA,OAAA;AAvBJ;;AA4BE;EACE,uDAAA;EACA,mGAAA;EACA,sBAAA;AAzBJ;AA2BI;EAEE,sDAAA;AA1BN;AA6BI;EACE,uDAAA;AA3BN;AA8BI;EACE,yDAAA;AA5BN;AA+BI;EACE,yDAAA;AA7BN;;AAmCA;EACE,oEAAA;EACA,mDAAA;EACA,yDAAA;EACA,6CAAA;EACA,iBAAA;AAhCF;;AAmCA;EACE,mEAAA;EACA,kDAAA;AAhCF;;AAmCA;EACE,sEAAA;EACA,qDAAA;AAhCF;;AAmCA;EACE,qEAAA;EACA,oDAAA;AAhCF;;AAmCA;EACE,oEAAA;EACA,mDAAA;AAhCF;;AAmCA;EACE,oEAAA;EACA,mDAAA;AAhCF;;AAmCA;EACE,sEAAA;EACA,qDAAA;AAhCF;;AAmCA;EACE,uEAAA;EACA,sDAAA;AAhCF;;AAmCA;EACE,sEAAA;EACA,qDAAA;AAhCF;;AAmCA;EACE,qEAAA;EACA,oDAAA;AAhCF;;AAmCA;EACE,uEAAA;EACA,sDAAA;AAhCF;;AAmCA;EACE,qEAAA;EACA,oDAAA;AAhCF;;AAmCA;EACE,oEAAA;EACA,mDAAA;AAhCF;;AAmCA;EACE,uEAAA;EACA,sDAAA;AAhCF;;AAmCA;EACE,uEAAA;EACA,sDAAA;AAhCF;;AAoCE;EACE,yDAAA;AAjCJ;;AAsCA;EACE,kBAAA;EACA,kDAAA;AAnCF;;AAuCA;EACE,kBAAA;AApCF","sourcesContent":["/* Ids Icon Component */\n:host {\n  display: inline-flex;\n  align-self: center;\n  contain: layout;\n  place-self: center;\n  position: relative;\n}\n\nsvg {\n  color: var(--ids-icon-color-default);\n  height: var(--ids-icon-height-default);\n  width: var(--ids-icon-width-default);\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n.mirrored {\n  transform: scaleX(-1);\n}\n\n// Customizations for specific icons\n:host([icon='more']) svg,\n:host([icon='vertical-ellipsis']) svg  {\n  height: 19px;\n}\n\n:host([icon='add']) svg {\n  width: 17px;\n}\n\n:host([icon='logo']) svg {\n  path:nth-child(1) {\n    display: none; // hide trademark\n  }\n}\n\n:host([icon='logo-primary']) svg {\n  stroke: transparent;\n}\n\n:host([compact='true']) svg {\n  height: calc(var(--ids-button-icon-compact-height) - 2px);\n  width: calc(var(--ids-button-icon-compact-width) - 2px);\n}\n\n:host([icon='favicon']) {\n  color: var(--ids-icon-infor-color);\n\n  path:nth-child(2) {\n    fill: white;\n  }\n}\n\n:host([icon='genai']) {\n  .insights-stop-1 {\n    stop-color: var(--ids-button-ai-color-icon-primary);\n  }\n\n  .insights-stop-2 {\n    stop-color: var(--ids-button-ai-color-icon-secondary);\n  }\n}\n\n:host(.editor-forecolor) {\n  .stop-underline,\n  .stop-base {\n    stop-color: var(--ids-button-formatter-color-text-default);\n  }\n}\n\n:host(.editor-forecolor.is-active) {\n  .stop-underline {\n    stop-color: var(--forecolor-active-color);\n  }\n}\n\n:host(#m-10) {\n  margin-top: 10px;\n}\n\n.text-badge {\n  position: absolute;\n  background: var(--ids-text-badge-color-background-success);\n  color: var(--ids-text-badge-color-text);\n  text-align: center;\n  border-radius: var(--ids-text-badge-border-radius);\n  width: var(--ids-text-badge-width);\n  height: var(--ids-text-badge-height);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--ids-font-family-default);\n  font-size: var(--ids-font-size-xs);\n  padding: 0 6px;\n  border: 1.5px solid var(--ids-text-badge-color-border, var(--ids-color-background-default));\n  box-sizing: border-box;\n\n  &.top-right {\n    bottom: calc(100% - calc(var(--ids-text-badge-height) / 2));\n    left: calc(100% - calc(var(--ids-text-badge-width) / 2));\n  }\n\n  &.top-left {\n    bottom: calc(100% - calc(var(--ids-text-badge-height) / 2));\n    right: calc(100% - calc(var(--ids-text-badge-width) / 2));\n  }\n\n  &.error {\n    background: var(--ids-notification-badge-error-color-background);\n  }\n\n  &.success {\n    background: var(--ids-notification-badge-success-color-background);\n  }\n\n  &.warning {\n    background: var(--ids-notification-badge-warning-color-background);\n  }\n\n  &.info {\n    background: var(--ids-notification-badge-info-color-background);\n  }\n}\n\n.notification-badge {\n  background-color: var(--ids-notification-badge-error-color-background);\n  border-radius: var(--ids-notification-badge-border-radius);\n  height: var(--ids-notification-badge-size);\n  width: var(--ids-notification-badge-size);\n  position: absolute;\n  border: 1.5px solid var(--ids-notification-badge-color-border, var(--ids-color-background-default));\n  box-sizing: border-box;\n\n  // Color notification badges\n  &.info,\n  &.base {\n    background-color: var(--ids-notification-badge-info-color-background);\n  }\n\n  &.error {\n    background-color: var(--ids-notification-badge-error-color-background);\n  }\n\n  &.success {\n    background-color: var(--ids-notification-badge-success-color-background);\n  }\n\n  &.warning {\n    background-color: var(--ids-notification-badge-warning-color-background);\n  }\n\n  /**\n  * positioning notification badge\n  */\n  &.top-right {\n    bottom: calc(100% - var(--ids-notification-badge-size));\n    left: calc(100% - var(--ids-notification-badge-size));\n  }\n\n  &.top-left {\n    bottom: calc(100% - var(--ids-notification-badge-size));\n    left: 0;\n  }\n\n  &.bottom-right {\n    bottom: 0;\n    left: calc(100% - var(--ids-notification-badge-size));\n  }\n\n  &.bottom-left {\n    bottom: 0;\n    left: 0;\n  }\n}\n\n:host([disabled]) {\n  .notification-badge {\n    background-color: var(--ids-alert-color-error-disabled);\n    border: 1.5px solid var(--ids-notification-badge-color-border, var(--ids-color-background-default));\n    box-sizing: border-box;\n\n    &.info,\n    &.base {\n      background-color: var(--ids-alert-color-info-disabled);\n    }\n\n    &.error {\n      background-color: var(--ids-alert-color-error-disabled);\n    }\n\n    &.success {\n      background-color: var(--ids-alert-color-success-disabled);\n    }\n\n    &.warning {\n      background-color: var(--ids-alert-color-warning-disabled);\n    }\n  }\n}\n\n// Status Colors\n[class^=\"status-color\"] {\n  background-color: var(--ids-icon-status-color-blue-color-background);\n  color: var(--ids-icon-status-color-blue-color-text);\n  border-radius: var(--ids-icon-status-color-border-radius);\n  padding: var(--ids-icon-status-color-padding);\n  overflow: visible;\n}\n\n.status-color-red {\n  background-color: var(--ids-icon-status-color-red-color-background);\n  color: var(--ids-icon-status-color-red-color-text);\n}\n\n.status-color-orange {\n  background-color: var(--ids-icon-status-color-orange-color-background);\n  color: var(--ids-icon-status-color-orange-color-text);\n}\n\n.status-color-green {\n  background-color: var(--ids-icon-status-color-green-color-background);\n  color: var(--ids-icon-status-color-green-color-text);\n}\n\n.status-color-blue {\n  background-color: var(--ids-icon-status-color-blue-color-background);\n  color: var(--ids-icon-status-color-blue-color-text);\n}\n\n.status-color-teal {\n  background-color: var(--ids-icon-status-color-teal-color-background);\n  color: var(--ids-icon-status-color-teal-color-text);\n}\n\n.status-color-purple {\n  background-color: var(--ids-icon-status-color-purple-color-background);\n  color: var(--ids-icon-status-color-purple-color-text);\n}\n\n.status-color-gray {\n  background-color: var(--ids-icon-status-color-neutral-color-background);\n  color: var(--ids-icon-status-color-neutral-color-text);\n}\n\n.status-color-yellow {\n  background-color: var(--ids-icon-status-color-yellow-color-background);\n  color: var(--ids-icon-status-color-yellow-color-text);\n}\n\n.status-color-error {\n  background-color: var(--ids-icon-status-color-error-color-background);\n  color: var(--ids-icon-status-color-error-color-text);\n}\n\n.status-color-warning {\n  background-color: var(--ids-icon-status-color-warning-color-background);\n  color: var(--ids-icon-status-color-warning-color-text);\n}\n\n.status-color-alert {\n  background-color: var(--ids-icon-status-color-alert-color-background);\n  color: var(--ids-icon-status-color-alert-color-text);\n}\n\n.status-color-info {\n  background-color: var(--ids-icon-status-color-info-color-background);\n  color: var(--ids-icon-status-color-info-color-text);\n}\n\n.status-color-success {\n  background-color: var(--ids-icon-status-color-success-color-background);\n  color: var(--ids-icon-status-color-success-color-text);\n}\n\n.status-color-caution {\n  background-color: var(--ids-icon-status-color-caution-color-background);\n  color: var(--ids-icon-status-color-caution-color-text);\n}\n\n:host(.calendar-event-header-icon) {\n  svg {\n    background-color: var(--ids-color-transparent) !important;\n  }\n}\n\n// Ai Icon Adjustment\n[fill=\"#7928E1\"] {\n  color: transparent;\n  fill: var(--ids-button-ai-sparkle-icon-color-fill);\n}\n\n// Workaround for hard coded fill color\n[fill=\"#161618\"] {\n  fill: currentColor;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
